// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1LabelSchema: z.ZodTypeAny = z.object({
  id: z.number().int().describe("Unique identifier for the label"),
  name: z.coerce.string().describe("Name of the label"),
  sequence: z.number().int().describe("Sequence order for the label"),
  parent_id: z.number().int().describe("Parent label ID for hierarchical labels").nullish(),
  emoji: z.coerce.string().describe("Emoji identifier for the label").nullish(),
  active: z.boolean().describe("Whether the label is active (false means archived)"),
  external_id: z.coerce.string().describe("External ID for mapping with external systems (alphanumeric with underscores, max 512 chars)").nullish(),
  created_at: z.string().datetime().describe("ISO8601 timestamp of when the label was created").nullish(),
  updated_at: z.string().datetime().describe("ISO8601 timestamp of when the label was last updated").nullish(),
  tic: z.optional(z.object({
    uri: z.coerce.string().describe("Canonical TIC identifier (e.g., tic://trello/default/tags/abc123). Immutable once set."),
    tool_id: z.coerce.string().describe("Original external tool identifier (e.g., trello, jira).").nullish(),
    external_url: z.coerce.string().describe("Direct link to the label/tag in the external tool.").nullish(),
  }).describe("Integration metadata (internal only). Present for synced labels.")),
  children: z.optional(z.array(z.lazy(() => v1LabelSchema)).describe("Child labels in the hierarchy (recursive structure)")),
});
